import { AddCircle } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '~/contexts';
import { NewDialog } from './';

export const NewButton = () => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        color="primary"
        disabled={!currentNetwork.canCreateDataSources.value}
        onClick={() => setDialogOpen(true)}
        startIcon={<AddCircle />}
        variant="contained"
      >
        {t('pages.data_sources.buttons.new')}
      </Button>

      <NewDialog
        close={() => setDialogOpen(false)}
        networkId={currentNetwork.id}
        open={dialogOpen}
      />
    </>
  );
};
